import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'checkliste';
  currentStep: number = 1;
  isCompleted: boolean = false;
  formdata: any = FormGroup;
  appHasPassed: boolean = true;
  rating: number = 0.0;
  conclusion: string = '';

  wizard1 = {
    choices: [
      { 
        weight: 5, 
        name: "<p>l’app descrive il campo concreto di applicazione, per es. un promemoria quotidiano per l’assunzione di medicinali;</p>",
        text: { title: 'Scopo e funzionalità', description: 'Indipendentemente dalle esigenze personali, l’app dovrebbe in genere soddisfare i seguenti requisiti per garantire un funzionamento sicuro e stabile:'}
      },
      { 
        weight: 5, 
        name: 'l’app indica chiaramente i propri limiti (per es. informazione che l’app non sostituisce un colloquio con il medico);'
      },
      { 
        weight: 2.5, 
        name: 'l’ultimo aggiornamento dell’app è stato rilasciato negli ultimi 6 mesi (termine indicativo);',
      },
      { 
        weight: 2.5, 
        name: 'il funzionamento è stabile e non è soggetto a interruzioni o riavvii;',
      },
      {  
        weight: 10, 
        name: 'l’app non formula una diagnosi definitiva da cui deriva suggerimenti per la terapia;',
        text: {title: 'App di diagnostica e trattamento', description: 'Controlli che un’app soddisfi sempre i seguenti due punti:'}
      },
      {  
        weight: 5, 
        name: 'l’app funge da aiuto alla terapia (per es. registrazione di valori).' 
      },
      {  
        weight: 2.5, 
        name: 'L’app ha ricevuto molte recensioni positive (da parte di molti utenti diversi).',
        text: { title: 'Valutazione da parte di altri utenti', description: ''}
      }
    ]
  };

  wizard2 = {
    choices: [
      { 
        weight: 5, 
        name: 'L’app è stata certificata ed è dotata di un marchio affidabile.',
        text: { title: 'Marchio o certificazione', description: ''}
      },
      {  
        weight: 2.5, 
        name: 'I criteri di valutazione associati al marchio sono chiari e comprensibili.'
      },
      { 
        weight: 5,
        ko_criteria: 1, 
        is_parent: 1,
        name: 'L’app ha una dichiarazione sulla protezione dei dati che:',
        text: { title: 'Dichiarazione sulla protezione dei dati', description: 'In generale l’app dovrebbe avere una dichiarazione sulla protezione dei dati che soddisfi i punti seguenti.'}
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'è facile da trovare e da visualizzare (per es. si trova direttamente nell’app, sul sito web o nel negozio online del fornitore);',
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'dà informazioni sul tipo, l’entità e lo scopo della raccolta e dell’uso dei dati, nonché sulla loro possibile trasmissione a terzi;' 
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'indica dove (in quale Paese) e in che modo (crittografati/anonimizzati) vengono archiviati i dati;',
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'indica se e come (per e-mail, posta, ecc.) l’utente può opporsi alla memorizzazione dei dati.' 
      },
      { 
        weight: 5, 
        name: 'l’app richiede esclusivamente i dati personali che appaiono importanti per la funzionalità;',
        text: { title: 'Scopo e funzionalità', description: 'In generale le app dovrebbero avere le seguenti caratteristiche se richiedono e/o registrano dati personali dell’utente:'}
      },
      { 
        weight: 5, 
        name: 'l’accesso a funzioni dei dispositivi mobili (per es. la condivisione della posizione tramite GPS o l’accesso al calendario) viene richiesto solo quando è necessario per garantire il funzionamento dell’applicazione;' 
      },
      { 
        weight: 5, 
        name: 'l’app offre la possibilità di cancellare nuovamente i dati raccolti e memorizzati. Siccome il più delle volte non è possibile un’eliminazione completa dei dati, rifletta sempre attentamente su quali dati rendere noti. ' 
      }
    ]
  };

  wizard3 = {
    choices: [
      { 
        weight: 5, 
        ko_criteria: 1,
        name: 'nome e indirizzo del fornitore. Particolarità per le persone giuridiche (es. Sagl o SA): indicazione della forma giuridica e delle persone con diritto di rappresentanza;',
        text: { title: 'Impressum', description: 'L’impressum di un’app deve contenere le seguenti indicazioni minime:'},
      },
      { 
        weight: 5, 
        name: 'dati per la presa di contatto diretta e immediata (numero di telefono o fax o indirizzo e-mail).',
      },
      { 
        weight: 5, 
        name: "Il contesto finanziario è visibile, per es.: <br><br> • l’app si finanzia da sola ed è a pagamento; <br><br> • il costo dell'app è rimborsato dalla cassa malati (molto raro); <br><br> • l’app è finanziata da sponsor e/o sovvenzioni.<br><br>",
        text: { title: 'Forma di finanziamento e contesto finanziario', description: ''}, 
      },
      { 
        weight: 5, 
        name: 'L’app è neutrale, ossia i contenuti non sono influenzati da interessi commerciali, per es.: <br><br> • l’app non fa pubblicità a un determinato prodotto; <br><br> • l’app è gestita da un’organizzazione pubblica o di pubblica utilità.',
      }
    ]
  };


  constructor(private formsModule: FormsModule, private formBuilder: FormBuilder) {
    this.formdata = this.formBuilder.group({
      wizard1_choices: new FormArray([]),
      wizard2_choices: new FormArray([]),
      wizard3_choices: new FormArray([])
    });

    this.addCheckboxes();
  }

  private addCheckboxes() {
    this.wizard1.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard1_choices as FormArray).push(control);
    });

    this.wizard2.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard2_choices as FormArray).push(control);
    });

    this.wizard3.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard3_choices as FormArray).push(control);
    });
  }

  onCheckboxChange(checkbox, checked) {
    this.formdata.controls.wizard2_choices.value.forEach((value, index) => {
      if(checkbox.hasOwnProperty('is_parent') && this.wizard2.choices[index].hasOwnProperty('is_sub')) {
        if(!checked) {
          this.formdata.controls.wizard2_choices.controls[index].setValue(false);
        }
      } else if(checkbox.hasOwnProperty('is_sub') && this.wizard2.choices[index].hasOwnProperty('is_parent')) {
        if(checked) {
          this.formdata.controls.wizard2_choices.controls[index].setValue({value: true});
        }
      }
    });
  }

  onStep1Next() {
    this.currentStep = 2;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onStep2Next() {
    this.currentStep = 3;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onStep3Next() {
    this.currentStep = 3;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onComplete() {
      window.top.scroll(0,0);
      window.scroll(0,0);
     this.isCompleted = true;

     this.formdata.controls.wizard1_choices.value.forEach((choice, index) => {
       if(this.wizard1.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard1.choices[index].weight;
       }
     });

     this.formdata.controls.wizard2_choices.value.forEach((choice, index) => {
       if(this.wizard2.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard2.choices[index].weight;
       }
     });

     this.formdata.controls.wizard3_choices.value.forEach((choice, index) => {
       if(this.wizard3.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard3.choices[index].weight;
       }
     });

     if(this.appHasPassed && this.rating >= 0 && this.rating <= 40) {
       this.conclusion = "L’app da Lei esaminata corrisponde molto poco alle raccomandazioni per un'app per la salute. Sia ben consapevole dei rischi se malgrado tutto decide di utilizzarla.";
     } else if(this.appHasPassed && this.rating > 40 && this.rating <= 84) {
       this.conclusion = "L’app in esame corrisponde in ampia misura alle raccomandazioni, ma alcuni criteri non sono soddisfatti. Valuti da sé se i criteri soddisfatti sono sufficienti per Lei.";
     } else if(this.appHasPassed && this.rating > 84 && this.rating <= 99) {
       this.conclusion = "L’app in esame soddisfa (quasi) tutti i criteri raccomandati dall’Alleanza tedesca per la sicurezza dei pazienti (Aktionsbündnis Patientensicherheit e.V.).";
     } else if(this.appHasPassed && this.rating > 99) {
       this.conclusion = "L’app in esame soddisfa tutti i criteri raccomandati dall’Alleanza tedesca per la sicurezza dei pazienti (Aktionsbündnis Patientensicherheit e.V.).";
     } else if(!this.appHasPassed) {
       this.conclusion = "Nell’app in esame non esiste una dichiarazione sulla protezione dei dati e / o non è presente l’impressum,  per cui sconsigliamo di utilizzarla.";
     }
  }

  exit() {
    window.top.location.href = 'https://www.aps-ev.de/'; //window.top.location.origin
  }

  reload() {
    window.location.reload();
    window.top.scroll(0,0);
    window.scroll(0,0);
  }
}
